import { Link, useNavigate } from "react-router-dom";
import logo from '../assets/img/logo.png'
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchSettings } from "../store/slices/settingsSlice";
import { SYSTEM_SETTINGS } from "../utils/configConstants";

function TopBar(props) {
    const [activeRoute, setActiveRoute] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const classicRoutes = [
        {
            id: 1,
            label: "Home",
            route: "/",
            icon: "icon-home pr-2 pt-1",
            isActive: false,
        },
        {
            id: 2,
            label: "New",
            route: "/order",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        },
        {
            id: 3,
            label: "History",
            route: "/order-history",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        },
    ]
    
    const navs = SYSTEM_SETTINGS.isClassicMode ? classicRoutes : [
        {
            id: 1,
            label: "Dashboard",
            route: "/",
            icon: "icon-home pr-2 pt-1",
            isActive: false,
        },
        {
            id: 2,
            label: "Categories",
            route: "/categories",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        },
        {
            id: 3,
            label: "Products",
            route: "/products",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        },
        {
            id: 4,
            label: "Users",
            route: "/users",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        },
        {
            id: 5,
            label: "Orders",
            route: "/orders",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        },
        {
            id: 6,
            label: "File Manager",
            route: "/filemanager",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        },
        {
            id: 7,
            label: "Notifications",
            route: "/notification",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        },
        {
            id: 8,
            label: "Blogs",
            route: "/blog",
            icon: "icon-blog pr-2 pt-1",
            isActive: false,
        },
        {
            id: 9,
            label: "Tickets",
            route: "/ticket",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        },
        {
            id: 10,
            label: "Reporting",
            route: "/reports",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        },
        {
            id: 11,
            label: "Settings",
            route: "/settings",
            icon: "icon-tasks pr-2 pt-1",
            isActive: false,
        }
    ];

    const switchRoute = (route) => {
        navigate(route);
        setActiveTab();
    }

    const setActiveTab = () => {
        setActiveRoute(window.location.pathname.split('/')[1]);
    }

    useEffect(() => {
        setActiveTab();
        dispatch(fetchSettings());
    }, []);

    return (
        <div className="h-full px-4 bg-blue-50 border-r dropshadow rounded-l flex" style={{overflow: 'scroll', scrollbarWidth: 'none'}}>
            {/* <div className="p-5 cursor-pointer"><img src={logo} width={100} alt={'WedaArana'} onClick={() => switchRoute(navs[0].route)}/></div> */}
            <div className="p-5 cursor-pointer"><div className="font-bold" onClick={() => switchRoute(navs[0].route)}>ASE Computers</div></div>
            <ul className="flex flex-row">{navs.map(nav => (<li key={nav.id} className={`cursor-pointer hover:bg-teal-400 hover:text-white ease-in duration-150 rounde px-4 py-2 m-2 flex justify-left items-center text-sm ${('/' + activeRoute) === nav.route ? "gradient-bg1 bg-teal-500 text-white" : "bg-slate-100"}`} onClick={() => switchRoute(nav.route)}><div className={nav.icon}></div><div>{nav.label}</div></li>))}</ul>
            {/* {!props.hidden ? <div className="md:hidden" style={{height: '100vh', width: '100vw', position: 'fixed', top: 0, zIndex: -3, backdropFilter: 'blur(5px)'}}></div> : ''} */}
        </div>
    );
}

export default TopBar;